import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "wpedit-editor" }
const _hoisted_2 = {
  for: "editorText",
  class: "col-form-label wpedit-editor__label"
}
const _hoisted_3 = { class: "wpedit-editor__block" }
const _hoisted_4 = { class: "wpedit-editor__toolbar" }
const _hoisted_5 = ["title", "onClick"]
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "emoji-picker position-absolute z-index-1" }

import {ref, Ref, onMounted, watch} from 'vue'
import EmojiPicker, {EmojiExt} from 'vue3-emoji-picker'


export default /*@__PURE__*/_defineComponent({
  __name: 'TextEditor',
  props: {
    selectedMessage: {}
  },
  emits: ['messageUpdated', 'contentUpdated'],
  setup(__props: any, { emit: __emit }) {

const textArea = ref<HTMLTextAreaElement | null>(null)
const isEmojiPickerOpen = ref(false)
const emit = __emit
const props = __props
const newMessage: Ref<string> = ref('')

const placeholders = [
  { description: 'common.placeholders.description.plate', label: 'common.placeholders.label.plate', value: '[[PLATE]]' },
  { description: 'common.placeholders.description.vehicle_color', label: 'common.placeholders.label.color', value: '[[COLOR]]' },
  { description: 'common.placeholders.description.username', label: 'common.placeholders.label.name', value: '[[USERNAME]]' },
  { description: 'common.placeholders.description.company_number', label: 'common.placeholders.label.number_pqr', value: '[[PQR-NUMBER]]' },
  { description: 'common.placeholders.description.place_name', label: 'common.placeholders.label.place_name', value: '[[PLACE]]' },
  { description: 'common.placeholders.description.company_name', label: 'common.placeholders.label.company_name', value: '[[COMPANY]]' },
]

onMounted(async() => {
  newMessage.value = props.selectedMessage
  emit('messageUpdated', newMessage.value)
})

function updateTextareaMessage() {
  const textarea = textArea.value
  if (textarea) {
    textarea.style.height = 'auto'
    textarea.style.height = `${textarea.scrollHeight}px`
  }
}

function insertPlaceholder(placeholder: string): void {
  if (placeholder && textArea.value) {
    const startPos = textArea.value.selectionStart ?? 0
    const endPos = textArea.value.selectionEnd ?? 0
    const scrollTop = textArea.value.scrollTop
    const value = textArea.value.value
    textArea.value.value = value.substring(0, startPos) + placeholder + value.substring(endPos, value.length)
    textArea.value.focus()
    textArea.value.setSelectionRange(startPos + placeholder.length, startPos + placeholder.length)
    textArea.value.scrollTop = scrollTop
  }
}

function applyStyleToSelection(style: string, text?: string): void {
  if (!textArea.value) return
  const startPos = textArea.value.selectionStart ?? 0
  const endPos = textArea.value.selectionEnd ?? 0
  const selectedText = text || (textArea.value.value.substring(startPos, endPos))
  const styledText = style === 'b' ? `*${selectedText}*` : `_${selectedText}_`
  const value = textArea.value.value
  textArea.value.value = value.substring(0, startPos) + styledText + value.substring(endPos, value.length)
  textArea.value.focus()
  const newEndPos = startPos + styledText.length - 1
  textArea.value.setSelectionRange(newEndPos, newEndPos)
}

function applyStyle(style: string): void {
  if (style === 'b' || style === 'i') {
    applyStyleToSelection(style)
  }
}

function insertTextAtCursor(text: string): void {
  newMessage.value += text
  if (textArea.value) {
    textArea.value.focus()
  }
}

function letterBold(): void {
  applyStyle('b')
}

function letterItalic(): void {
  applyStyle('i')
}

function insertEmoji(emoji: EmojiExt): void {
  if (emoji.i) {
    insertTextAtCursor(emoji.i)
    toggleEmojiPicker()
  }
}

function toggleEmojiPicker(): void {
  isEmojiPickerOpen.value = !isEmojiPickerOpen.value;
}

watch(newMessage, (newValue) => {
    let content = newValue
    const tabs = content.match(/\t/g) || []
    const newLines = content.match(/\n/g) || []

    content = content
        .replace(/\*([^*]+)\*/g, '<b>$1</b>')
        .replace(/_([^_]+)_/g, '<i>$1</i>')

    for (let i = 0; i < tabs.length; i++) {
        content = content.replace(/\t/, '&#9;')
    }

    for (let i = 0; i < newLines.length; i++) {
        content = content.replace(/\n/, '<br>')
    }

    emit('contentUpdated', content)
    emit('messageUpdated', newMessage.value)
})

watch(() => props.selectedMessage, (newValue) => {
    newMessage.value = newValue
    if (textArea.value) {
        textArea.value.value = newValue
        updateTextareaMessage()
    }
    emit('messageUpdated', newMessage.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('common.fields.label_message')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "bold-button wpedit-editor__tool-btn wpedit-editor__tool-btn--bold",
          onClick: letterBold
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("b", null, "B", -1)
        ]))]),
        _createElementVNode("button", {
          class: "italic-button wpedit-editor__tool-btn wpedit-editor__tool-btn--italic",
          onClick: letterItalic
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("span", { class: "fs-6" }, "I", -1),
          _createElementVNode("i", null, null, -1)
        ]))]),
        _createElementVNode("button", {
          class: "emoji-button wpedit-editor__tool-btn wpedit-editor__tool-btn--emoji",
          onClick: toggleEmojiPicker
        }, " 😀 "),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "wpedit-editor__divider" }, null, -1)),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(placeholders, (placeholder, index) => {
          return _createElementVNode("span", {
            key: index,
            class: "tooltip-element wpedit-editor__chip",
            "data-bs-toggle": "tooltip",
            title: _ctx.$t(placeholder.description),
            onClick: ($event: any) => (insertPlaceholder(placeholder.value))
          }, _toDisplayString(_ctx.$t(placeholder.label)), 9, _hoisted_5)
        }), 64))
      ]),
      _withDirectives(_createElementVNode("textarea", {
        rows: "5",
        ref_key: "textArea",
        ref: textArea,
        id: "editorText",
        class: "text-area-Message wpedit-editor__textarea",
        contenteditable: "true",
        placeholder: _ctx.$t('wp.placeholders.editor_message'),
        onInput: updateTextareaMessage,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newMessage).value = $event))
      }, null, 40, _hoisted_6), [
        [_vModelText, newMessage.value]
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createVNode(_unref(EmojiPicker), { onSelect: insertEmoji })
    ], 512), [
      [_vShow, isEmojiPickerOpen.value]
    ])
  ]))
}
}

})